import type { ThemeConfig } from 'antd';

/**
 * Цветовая схема "Графит".
 * Primary совпадает по тону с чёрным логотипом RiChat —
 * акцент не "второй цвет", а продолжение айдентики.
 */
export const antdTheme: ThemeConfig = {
  token: {
    // Брендовый цвет
    colorPrimary: '#1F2937',
    colorPrimaryHover: '#374151',
    colorPrimaryActive: '#111827',
    colorLink: '#1F2937',
    colorLinkHover: '#374151',

    // Текст
    colorText: '#1A1A1A',
    colorTextSecondary: '#6B7280',
    colorTextTertiary: '#9CA3AF',

    // Границы и фоны
    colorBorder: '#E5E7EB',
    colorBorderSecondary: '#F3F4F6',
    colorBgLayout: '#F9FAFB',
    colorBgContainer: '#FFFFFF',

    // Радиусы
    borderRadius: 6,
    borderRadiusLG: 12,

    // Типографика
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 28,
    fontSizeHeading2: 22,
    fontSizeHeading3: 18,
    fontWeightStrong: 500,

    // Размеры
    controlHeight: 36,
    controlHeightLG: 42,
    paddingContentHorizontal: 16,
  },
  components: {
    Button: {
      fontWeight: 500,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Layout: {
      headerBg: '#FFFFFF',
      siderBg: '#F9FAFB',
      bodyBg: '#F9FAFB',
      headerHeight: 56,
      headerPadding: '0 24px',
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: '#F3F4F6',
      itemSelectedColor: '#1F2937',
      itemHoverBg: '#F3F4F6',
      itemHoverColor: '#1F2937',
      itemHeight: 40,
      iconSize: 16,
    },
    Card: {
      headerFontSize: 16,
      paddingLG: 24,
    },
    Input: {
      activeShadow: '0 0 0 2px rgba(31, 41, 55, 0.1)',
    },
    Form: {
      labelColor: '#6B7280',
      labelFontSize: 13,
      verticalLabelPadding: '0 0 4px',
    },
  },
};
